/* eslint-disable import/prefer-default-export */
/**
 * String sorter utility for table columns
 * @param {string} a - First string to compare
 * @param {string} b - Second string to compare
 * @returns {number} - Comparison result (-1, 0, or 1)
 */
export const stringSorter = (a, b) => {
  const stringA = a?.toUpperCase() || '';
  const stringB = b?.toUpperCase() || '';
  if (stringA < stringB) {
    return -1;
  }
  if (stringA > stringB) {
    return 1;
  }
  return 0;
};
